import React from 'react';
import {
  CardProducElement,
  CardProductDetail,
  CardProductImage,
  CardProductPriceCta,
} from './CardProductVertical.styles';
import { Text, Title } from '@/components/typography';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import TravelDetailList from '@/features/pacote/components/TravelDetailList/TravelDetailList';
import CardMedia from '@/components/card/CardMedia/CardMedia';
import { useTranslations } from 'next-intl';
import TagsBadgeList from '@/features/pacote/components/TagsBadgeList/TagsBadgeList';

const CardProductVertical = ({ ...props }: PacoteItinerarySimilarType) => {
  const t = useTranslations('Pacote');
  const { title, permalink, media, travel_amount, travel_currency, travel_amount_info, tags } = props;

  return (
    <CardProducElement>
      <CardProductImage>
        <CardMedia
          media={media}
          href={permalink}
          minHeight={244}
          minHeightMobile={213.5}
          mediaOptions={{
            transform: { width: 437 * 2, height: 244 * 2, crop: 'fill' },
          }}
        />
        <TagsBadgeList tags={tags} position="absolute" />
      </CardProductImage>
      <CardProductDetail>
        <Link href={permalink}>
          <Title as="h3" size="lg">
            {title}
          </Title>
        </Link>
        <TravelDetailList {...props} />
      </CardProductDetail>
      <CardProductPriceCta>
        <Text as="span" textCase="uppercase" weight="light">
          {t('preço a partir')}
        </Text>
        <div>
          <Text as="span" size="xl" weight="bold">
            {(!travel_amount && (
              <Text as="small" size="md">
                {t('Consulte-nos')}
              </Text>
            )) || (
              <>
                <Text as="small" size="md">
                  {travel_currency}
                </Text>{' '}
                {travel_amount}
                {(travel_currency !== 'BRL' && <sup>*</sup>) || null}
              </>
            )}
          </Text>
          {(travel_amount && (
            <Text size="xs" as="small" textCase="uppercase">
              {travel_amount_info}
            </Text>
          )) ||
            null}
        </div>
        <Button href={permalink} block arrow appearance="outline">
          {t('VEJA O ROTEIRO')}
        </Button>
      </CardProductPriceCta>
    </CardProducElement>
  );
};

export default CardProductVertical;
